export enum UserTitle {
  Engineer = 'engineer',
  DataAIAndML = 'data_ai_ml',
  ProductManager = 'product_manager',
  Designer = 'designer',
  Founder = 'founder',
  Other = 'other',
}

export const USER_TITLES = Object.values(UserTitle)
